module.exports = __webpack_public_path__ + "img/7.fea437a1.jpg";